import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { SurveyQuestionService } from "../../services/survey-question.service";
import { SurveyService } from "../../services/survey.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { Utils } from "../../helper/utils.helper";

let SurveyInfo = {
    selector: "vcSurveyInfo",
    templateUrl: "/angular/components/survey/survey-info.component.html",
    bindings: {},
    controller: class SurveyInfoController {
        public sid: number | string;
        public loading = true;
        public isLeaderView: boolean;
        public app_type = "Walk";
        public noResultsImage = "no-surveys.svg";
        public survey: any;

        private readonly $scope: any;
        private readonly $timeout: any;
        private $window: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private utils: Utils;
        public __env: any;

        private service: SurveyService;
        private timeoutCode: any;
        private dataProvider: SurveyDataProvider;
        private surveyQuestionService: SurveyQuestionService;
        private campaignDataProvider: CampaignDataProvider;
        public navigationBarService: NavigationBarHelperService;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $timeout: any,
            DialogUtils: DialogUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            $routeParams: any,
            $window: any,
            ToastUtils: ToastUtils,
            __app_type: string,
            SurveyService: SurveyService,
            SurveyDataProvider: SurveyDataProvider,
            SurveyQuestionService: SurveyQuestionService,
            CampaignDataProvider: CampaignDataProvider,
            Utils: Utils,
            PermissionCheck: PermissionCheck,
            __env: any
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.utils = Utils;
            this.__env = __env;

            this.service = SurveyService;
            this.dataProvider = SurveyDataProvider;
            this.surveyQuestionService = SurveyQuestionService;
            this.campaignDataProvider = CampaignDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;

            Utils.accessCheck();
            this.sid = $routeParams.surveyId;
            this.isLeaderView = __app_type == "LEADER";
            if (this.isLeaderView) {
                this.noResultsImage = "no-surveys-leader.svg";
            }
            this.navigationBarService.setShowBackButton(true);

            this.permissionProvider.getFeaturePermissions().then(() => {
                if (
                    (this.permissionProvider.hasPermission("SURVEY") &&
                        !this.isLeaderView) ||
                    (this.permissionProvider.hasPermission("LEADER_ORGANIZE") &&
                        this.isLeaderView)
                ) {
                    this.service.info(this.sid).then((response: object) => {
                        const json = response["data"];
                        this.loading = false;
                        if (json.success) {
                            this.survey = json.data;
                        } else {
                            this.$window.location = "./#/survey/";
                        }

                        this.$scope.$watch(
                            () => this.survey.questions,
                            (newValue, oldValue) => {
                                if (newValue !== oldValue) {
                                    this.saveQuestionOrder();
                                }
                            },
                            true
                        );
                    });
                } else {
                    this.loading = false;
                }
            });
        }

        saveQuestionOrder(): void {
            this.$timeout.cancel(this.timeoutCode); //does nothing, if timeout already done
            this.timeoutCode = this.$timeout(() => {
                let ids = this.survey.questions.map(({ sqid }) => sqid);
                this.dataProvider.updateQuestionOrder(this.survey.sid, ids);
            }, 1000);
        }

        openErrorDialog(string: string, ev?: any): void {
            const content =
                string == "publish"
                    ? "Sorry but you need at least 1 question to publish a survey!"
                    : "Sorry but can't delete the only question associated with a survey!";

            let dialog = this.dialog
                .alert()
                .textContent(content)
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(dialog);
        }

        onDrop(item: object): object {
            return item;
        }

        removeQuestion(index: number): void {
            this.survey.questions.splice(index, 1);
        }

        updateSurvey(survey: any, teamOnly: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: survey,
                        teamOnly: teamOnly,
                    },
                })
                .then((survey: any) => {
                    this.toast.success("Survey updated");
                    this.survey.team = null;
                    angular.extend(this.survey, survey);
                });
        }

        toggleStatus(survey: any, ev: any): void {
            if (survey.osid) {
                let dialog = this.dialog
                    .alert()
                    .textContent(
                        "Sorry, this action can only be performed at organization level"
                    )
                    .targetEvent(ev)
                    .ok("OK");
                this.dialog.showPreConfiguredDialog(dialog);
            } else {
                if (
                    survey.questions.length <= 0 &&
                    survey.sstatus == "Not Live"
                ) {
                    this.openErrorDialog("publish");
                } else {
                    if (!survey.disabled || survey.disabled == "0") {
                        if (this.survey.sstatus) {
                            this.survey.sstatus =
                                this.survey.sstatus == "Live"
                                    ? "Not Live"
                                    : "Live";
                        }
                        this.dataProvider.update(this.survey);
                    }
                }
            }
        }

        toggleSignature(survey: any): void {
            survey.signature = survey.signature == "0" ? "1" : "0";
            this.dataProvider.update(survey);
        }

        exportSurvey(survey: any, ev: any): void {
            this.openExportSurvey(survey, ev);
        }

        openExportSurvey(survey: any, ev: any): void {
            if (!this.isLeaderView) {
                this.dialog.show({
                    component: "vc-result-export-dialog",
                    size: "large",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        survey: survey.sid,
                    },
                });
            } else {
                this.dialog.show({
                    component: "vc-organisation-result-export",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        survey: survey.sid,
                    },
                    size: "large",
                    ariaLabel: "Export Data",
                });
            }
        }

        questionModal(ev: any, question: any): void {
            if (!this.survey.osid && !this.survey.snbid) {
                this.dialog
                    .show({
                        component: "vc-survey-question-form",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            question: question,
                            sid: this.survey.sid,
                            deleteSurveyQuestion: this.utils.bindFunction(
                                this.deleteQuestion,
                                this
                            ),
                        },
                    })
                    .then((questionResponse: string) => {
                        if (questionResponse == "delete") {
                            return;
                        }
                        if (question.hasOwnProperty("sqid")) {
                            angular.extend(question, questionResponse);
                        } else {
                            this.survey.questions.push(questionResponse);
                            this.dataProvider.clearAll();
                        }
                    });
            } else {
                let message = this.survey.osid
                    ? "Sorry, this action can only be performed at organization level"
                    : "Sorry, Nationbuilder survey questions cannot be edited";
                let dialog = this.dialog
                    .alert()
                    .textContent(message)
                    .targetEvent(ev)
                    .ok("OK");
                this.dialog.showPreConfiguredDialog(dialog);
            }
        }

        deleteQuestion(question: any, ev: any): void {
            if (this.survey.questions.length <= 1) {
                this.openErrorDialog("delete");
            } else {
                if (this.isLeaderView) {
                    this.campaignDataProvider.getOrganisations().then(() => {
                        this.openDeleteQuestionDialog(question, ev);
                    });
                } else {
                    this.openDeleteQuestionDialog(question, ev);
                }
            }
        }

        openDeleteQuestionDialog(question: any, ev: any): void {
            let leaderString = "";
            if (this.isLeaderView) {
                leaderString =
                    "<p  class='layout-margin no-side-margin'>" +
                    "This will be deleted across all <span class='bold no-margin'>" +
                    this.campaignDataProvider.activeOrganisation.campaigns
                        .length +
                    " accounts</span> in your organization account.</p>";
            }
            let confirm = this.dialog
                .confirm()
                .htmlContent(
                    "<p  class='layout-margin no-side-margin'>You are about to permanently delete this survey question, its responses and answer data.</p>" +
                        leaderString +
                        "<p  class='layout-margin no-side-margin'>This operation cannot be undone.</p>" +
                        "<p  class='layout-margin no-side-margin'>Click delete only if you are certain that you wish to proceed.</p>"
                )
                .targetEvent(ev)
                .title("Delete Question?")
                .ok("Delete")
                .cancel("Cancel");
            this.dialog.showPreConfiguredDialog(confirm).then(() => {
                this.surveyQuestionService
                    .delete(question.sqid)
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            let index = this.survey.questions.indexOf(question);
                            this.survey.questions.splice(index, 1);
                            this.toast.success("Question deleted");
                        } else {
                            this.toast.error();
                        }
                    });
            });
        }

        deleteSurvey(survey: any, ev: any): void {
            let leaderString = "";
            if (this.isLeaderView) {
                leaderString =
                    "<p  class='layout-margin no-side-margin'>" +
                    "This will be deleted across all <span class='bold no-margin'>" +
                    this.campaignDataProvider.activeOrganisation.campaigns
                        .length +
                    " campaigns</span> in your organization account.</p>";
            }
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete Survey?`,
                        bodyText:
                            "<p  class='layout-margin no-side-margin'>You are about to permanently delete this survey, its questions, responses and all associated data.</p>" +
                            leaderString +
                            "<p  class='layout-margin no-side-margin'>Click confirm if you are certain that you wish to proceed.</p>",
                    },
                })
                .then(() => {
                    this.service.delete(survey.sid).then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.dataProvider.clearAll();
                            if (this.isLeaderView) {
                                this.$window.location =
                                    "./leader.php#/leader_survey/";
                            } else {
                                this.$window.location = "./#/survey/";
                            }
                        } else {
                            this.toast.error();
                        }
                    });
                });
        }
    },
};

angular.module("survey").component(SurveyInfo.selector, SurveyInfo);
